import { useSelector, useDispatch } from 'react-redux'
import { itemsFetchData } from '../../redux/items'

const ClearAll = ({ onClick }) => {
  const currentFilters = useSelector((state) => state.items.currentFilters)
  const dispatch = useDispatch()

  const handleClick = () => {
    dispatch(itemsFetchData({}))

    onClick()
  }

  const clearableFilters = () => {
    const filter = { ...currentFilters }
    delete filter.sort
    return Object.keys(filter)
  }

  return (
    <>
      {(window.location.pathname !== `/${I18n.t('routes.cars')}` ||
        clearableFilters().length > 0) && (
        <button
          className="btn btn-sm py-1 my-1 ms-1 rounded-8"
          style={{ border: '1px solid #EDE9E5' }}
          onClick={handleClick}
          type="button"
        >
          <i className="fas fa-times me-2" />
          <span>{I18n.t('clear_all')}</span>
        </button>
      )}
    </>
  )
}

export default ClearAll
